import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../../assetManifest.js";

interface MenuScreenProps {
  onStartEndless: () => void;
  onStartRush: () => void;
  onStartSeeded: (seed: string) => void;
  onCopyShareCode: () => void;
  isLoading: boolean;
}

const MenuScreen: React.FC<MenuScreenProps> = ({
  onStartEndless,
  onStartRush,
  onStartSeeded,
  onCopyShareCode,
  isLoading,
}) => {
  return (
    <div className="menu-screen h-full w-full bg-bg-main flex flex-col items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-center mb-8"
      >
        <img src={ASSETS.images.logo.path} alt="Coffee Break Logo" className="menu-logo w-32 h-32 mx-auto mb-4" />
        <h1 className="menu-title text-4xl font-bold text-text-primary">Choose Your Mode</h1>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="bg-surface p-8 rounded-lg shadow-md border border-border-color w-full max-w-sm space-y-4"
      >
        <button
          onClick={onStartEndless}
          disabled={isLoading}
          className="w-full bg-primary-action text-white font-bold py-4 rounded-lg text-xl hover:bg-accent transition-all hover:scale-105 disabled:bg-gray-400 disabled:cursor-wait"
        >
          ♾️ Play Endless
        </button>
        <button
          onClick={onStartRush}
          disabled={isLoading}
          className="w-full bg-danger text-white font-bold py-4 rounded-lg text-xl hover:opacity-90 transition-all hover:scale-105 disabled:bg-gray-400 disabled:cursor-wait"
        >
          ⏱️ Play Rush (3:00)
        </button>
      </motion.div>
    </div>
  );
};

export default MenuScreen;
